export default __webpack_public_path__ + "static/media/alphabetical-order.d5d181a0.png";